<template>
  <div class="page-wrapper">
    <div class="page-container">
      <!-- Breadcrumb -->
      <div class="page-header">
        <div class="breadcrumb">
          <span class="crumb-link" @click="$router.push('/')">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
            Asosiy
          </span>
          <span class="separator">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </span>
          <span class="crumb-link" @click="$router.push('/tanlov-fanlar')">Tanlov fanlar</span>
          <span class="separator">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </span>
          <span class="crumb-link" @click="$router.go(-1)">O'qituvchilar</span>
          <span class="separator">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </span>
          <span class="crumb-current">O'qituvchi ishi</span>
        </div>
      </div>

      <div class="table-card">
        <div class="card-header">
          <div class="teacher-profile">
            <div class="teacher-avatar">
              <img v-if="teacherImage" :src="teacherImage" @error="handleImgError" alt="O'qituvchi" class="avatar-img" />
              <div v-else class="avatar-placeholder">{{ getInitials(teacherName) }}</div>
            </div>
            <div class="teacher-info">
              <h2 class="card-title">
                {{ teacherName }}
              </h2>
              <div class="teacher-meta">
                <span v-if="teacherPosition" class="meta-tag position-tag">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                  {{ teacherPosition }}
                </span>
                <span v-if="teacherDepartment" class="meta-tag department-tag">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                  {{ teacherDepartment }}
                </span>
                <span v-if="teacherDegree" class="meta-tag degree-tag">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg>
                  {{ teacherDegree }}
                </span>
                <span v-if="teacherRank" class="meta-tag rank-tag">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline></svg>
                  {{ teacherRank }}
                </span>
              </div>
            </div>
          </div>
          
          <div class="tabs">
            <button 
              v-for="tab in tabs" 
              :key="tab.id" 
              class="tab-btn" 
              :class="{ 'active-tab': activeTab === tab.id }"
              @click="setTab(tab.id)"
            >
              {{ tab.label }}
            </button>
          </div>
        </div>

        <div class="card-body">
          <div v-if="loading" class="loading-container">
            <div class="spinner"></div>
            <span class="loading-text">Ma'lumotlar yuklanmoqda...</span>
          </div>
          
          <div v-else-if="activities.length === 0" class="empty-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="margin: 0 auto 16px;"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
            <p>Ushbu bo'lim bo'yicha ma'lumot topilmadi.</p>
          </div>
          
          <div v-else class="activities-list">
            <div v-for="(act, idx) in activities" :key="idx" class="activity-item">
              
              <!-- Ilmiy faollik (Profil/Platforma) -->
              <div v-if="activeTab === 'scientific-activity-list'">
                <div class="activity-type">Ilmiy profil</div>
                <div class="activity-title" style="margin-bottom: 8px;">
                  <a v-if="act.profile_link" :href="act.profile_link" target="_blank" style="color: #1e293b; text-decoration: none;">
                    {{ act.profile_link }}
                  </a>
                  <span v-else>Profil havolasi kiritilmagan</span>
                </div>
                
                <div class="activity-meta" style="margin-top: 12px;">
                  <span class="meta-badge" v-if="act.h_index !== null">
                    <strong>H-Index:</strong> {{ act.h_index }}
                  </span>
                  <span class="meta-badge" v-if="act.publication_work_count !== null">
                    <strong>Asarlar soni:</strong> {{ act.publication_work_count }}
                  </span>
                  <span class="meta-badge" v-if="act.citation_count !== null">
                    <strong>Iqtiboslar:</strong> {{ act.citation_count }}
                  </span>
                  <span class="meta-badge" v-if="act._education_year || act.education_year?.name">
                    <strong>Yil:</strong> {{ act._education_year || act.education_year?.name }}
                  </span>
                </div>
              </div>

              <!-- Nashrlar va Mulklar -->
              <div v-else>
                <div class="activity-type">
                  {{ activeTab === 'publication-methodical-list' ? 'Uslubiy nashr' : 
                     activeTab === 'publication-scientifical-list' ? 'Ilmiy nashr' : 
                     activeTab === 'publication-property-list' ? 'Intelektual mulk' : 'Ma\'lumot' }}
                </div>
                <div class="activity-title">{{ act.name || act.topic || act.title || 'Nomsiz' }}</div>
                
                <div class="activity-meta">
                  <span v-if="act.issue_year || (act.property_date && act.property_date.date)" class="meta-badge">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                    {{ act.issue_year || (act.property_date ? act.property_date.date.substring(0, 4) : '') }}
                  </span>
                  
                  <span v-if="act.authors || act.author" class="meta-badge">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                    {{ act.authors || act.author }}
                  </span>
                  
                  <span v-if="act.publisher || act.source_name" class="meta-badge">
                    <strong>Manba:</strong> {{ act.publisher || act.source_name }}
                  </span>
                  
                  <span v-if="act.numbers" class="meta-badge">
                    <strong>№:</strong> {{ act.numbers }}
                  </span>
                  
                  <a v-if="act.file_url" :href="act.file_url" target="_blank" class="meta-badge" style="color: #3b82f6; text-decoration: none;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="12" y1="18" x2="12" y2="12"></line><line x1="9" y1="15" x2="15" y2="15"></line></svg>
                    Faylni ko'rish
                  </a>
                </div>
              </div>

            </div>
            
            <!-- Pagination -->
            <div class="pagination" v-if="pageCount > 1">
              <button :disabled="page === 1" @click="changePage(page - 1)" class="page-btn">Oldingi</button>
              <span class="page-info">{{ page }} / {{ pageCount }}</span>
              <button :disabled="page === pageCount" @click="changePage(page + 1)" class="page-btn">Keyingi</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
const API = process.env.VUE_APP_API_URL;

export default {
  name: "OqituvchiIshi",
  data() {
    return {
      employeeId: "",
      teacherName: "",
      teacherImage: "",
      teacherPosition: "",
      teacherDepartment: "",
      teacherDegree: "",
      teacherRank: "",
      activities: [],
      loading: false,
      page: 1,
      pageCount: 1,
      activeTab: "scientific-activity-list",
      tabs: [
        { id: "scientific-activity-list", label: "Ilmiy faollik" },
        { id: "publication-methodical-list", label: "Uslubiy nashrlar" },
        { id: "publication-scientifical-list", label: "Ilmiy nashrlar" },
        { id: "publication-property-list", label: "Intelektual mulklar" },
      ]
    };
  },
  mounted() {
    this.employeeId = this.$route.query.employee_id;
    this.teacherName = this.$route.query.name || "";
    const imgUrl = this.$route.query.image || "";
    if (imgUrl && (imgUrl.includes('hemis.tdmau.uz') || imgUrl.startsWith('http')) && !imgUrl.includes('/image-proxy')) {
      this.teacherImage = `${API}/image-proxy?url=${encodeURIComponent(imgUrl)}`;
    } else {
      this.teacherImage = imgUrl;
    }
    this.teacherPosition = this.$route.query.position || "";
    this.teacherDepartment = this.$route.query.department || "";
    this.teacherDegree = this.$route.query.degree || "";
    this.teacherRank = this.$route.query.rank || "";
    
    if (this.employeeId) {
      this.fetchActivities(1);
    }
  },
  methods: {
    handleImgError() {
      this.teacherImage = "";
    },
    getInitials(name) {
      if (!name) return "";
      const parts = name.split(" ");
      if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
      return name.substring(0, 2).toUpperCase();
    },
    setTab(tabId) {
      if (this.activeTab !== tabId) {
        this.activeTab = tabId;
        this.fetchActivities(1);
      }
    },
    async fetchActivities(pageNum) {
      this.loading = true;
      this.page = pageNum;
      
      try {
        const res = await axios.get(`${API}/${this.activeTab}`, {
          params: { employee_id: this.employeeId, page: this.page, limit: 10 }
        });
        if (res.data.success) {
          let items = [];
          const raw = res.data.data;
          
          if (raw && raw[0] && raw[0].items) {
             items = raw[0].items;
             this.pageCount = raw[0].pagination ? (Array.isArray(raw[0].pagination) ? raw[0].pagination[0].pageCount : raw[0].pagination.pageCount) : 1;
          }
          else if (raw && raw.items) {
             items = raw.items;
             this.pageCount = raw.pagination ? (Array.isArray(raw.pagination) ? raw.pagination[0].pageCount : raw.pagination.pageCount) : 1;
          }
          else if (Array.isArray(raw)) {
             items = raw;
             this.pageCount = 1;
          }
          this.activities = items;
        }
      } catch (err) {
        console.error("Ma'lumot yuklashda xatolik:", err);
      } finally {
        this.loading = false;
      }
    },
    changePage(newPage) {
      if (newPage >= 1 && newPage <= this.pageCount) {
        this.fetchActivities(newPage);
      }
    }
  }
};
</script>

<style scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: linear-gradient(135deg, #f0f2f5 0%, #e8ecf1 100%);
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
}

.page-container {
  flex: 1;
  padding: 28px 36px;
  width: 100%;
}

.page-header {
  margin-bottom: 24px;
}

.breadcrumb {
  font-size: 15px;
  font-weight: 500;
  color: #6c757d;
  display: flex;
  align-items: center;
  gap: 8px;
}

.crumb-link {
  color: #7c8db0;
  cursor: pointer;
  transition: color 0.2s;
  display: flex;
  align-items: center;
  gap: 4px;
}

.crumb-link:hover {
  color: #4361ee;
}

.separator {
  color: #c5cdd8;
  display: flex;
  align-items: center;
}

.crumb-current {
  color: #374151;
  font-weight: 600;
}

.table-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.06);
  overflow-x: auto;
}

.card-header {
  padding: 24px 30px;
  border-bottom: 1px solid #e2e8f0;
  background: #fdfdfd;
}

.teacher-profile {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 24px;
}

.teacher-avatar {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  overflow: hidden;
  background: #e2e8f0;
  flex-shrink: 0;
  border: 3px solid #fff;
  box-shadow: 0 4px 10px rgba(0,0,0,0.08);
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  color: white;
  font-weight: 700;
  font-size: 24px;
}

.teacher-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.card-title {
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.teacher-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.meta-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 20px;
}

.position-tag {
  background: #f0fdf4;
  color: #16a34a;
  border: 1px solid #bbf7d0;
}

.department-tag {
  background: #eff6ff;
  color: #2563eb;
  border: 1px solid #bfdbfe;
}

.degree-tag {
  background: #fdf4ff;
  color: #c026d3;
  border: 1px solid #f5d0fe;
}

.rank-tag {
  background: #fffbeb;
  color: #d97706;
  border: 1px solid #fde68a;
}

.tabs {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.tab-btn {
  background: transparent;
  border: 1px solid #cbd5e1;
  padding: 8px 18px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s;
}

.tab-btn:hover {
  background: #f1f5f9;
  color: #334155;
}

.tab-btn.active-tab {
  background: #3b82f6;
  color: white;
  border-color: #3b82f6;
  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.3);
}

.card-body {
  padding: 30px;
}

.loading-container {
  padding: 60px;
  text-align: center;
}

.spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #e2e8f0;
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto 20px;
}

.loading-text {
  font-size: 15px;
  color: #94a3b8;
  font-weight: 500;
}

.empty-container {
  padding: 60px;
  text-align: center;
}

.empty-container p {
  color: #64748b;
  font-size: 15px;
  font-weight: 500;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.activities-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.activity-item {
  padding: 20px;
  background: #fdfdfd;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  transition: box-shadow 0.2s, transform 0.2s;
}

.activity-item:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  transform: translateY(-2px);
  border-color: #cbd5e1;
}

.activity-type {
  display: inline-block;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 6px;
  margin-bottom: 12px;
  text-transform: uppercase;
}

.activity-title {
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 14px;
  line-height: 1.5;
}

.activity-meta {
  font-size: 14px;
  color: #64748b;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.meta-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f1f5f9;
  padding: 4px 10px;
  border-radius: 6px;
  font-weight: 500;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e2e8f0;
}

.page-btn {
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
  transition: all 0.2s;
}

.page-btn:hover:not(:disabled) {
  background: #e2e8f0;
  color: #0f172a;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  font-size: 15px;
  font-weight: 600;
  color: #475569;
}
</style>
